<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { store } from '@/store/store';

const route = useRoute()
const router = useRouter();

const enableEventSpecific = computed(() => {
    return route.meta.eventSpecific
})

let loggedIn = computed(() => {
  return route.meta.loggedIn
})

function goEvents() {
    store.currentEventName = null
    router.push("/events")
}

function goMyShifts() {
    let eventId = route.path.substring(route.path.lastIndexOf("/") + 1)
    router.push("/schedule/" + eventId )
}

function goToSignup() {
    let eventId = route.path.substring(route.path.lastIndexOf("/") + 1)
    router.push("/signup/" + eventId )
}

const location = computed(() => {
    return route.meta.nav
})

</script>

<template>
    <v-bottom-navigation v-model="location" v-if="loggedIn" class="volcor-footer">
        <v-btn value="events" @click="goEvents()" >
            <v-icon icon="mdi-view-list-outline" /> Events
        </v-btn>
        <v-btn value="schedule" @click="goMyShifts()" :disabled="!enableEventSpecific" >
            <v-icon icon="mdi-calendar-text-outline"></v-icon> My Schedule
        </v-btn>
        <v-btn value="signup" @click="goToSignup()" :disabled="!enableEventSpecific">
            <v-icon icon="mdi-calendar-edit-outline"></v-icon> Sign up
        </v-btn>
    </v-bottom-navigation>
</template>

<style scoped>
.volcor-footer {
  background-color: #004d4d !important;
  color: white !important;
}
</style>